import { isBlank, asNumber } from './detailShared'
// ADDENDUM 51 (§5.2) — «Requiere atención» de una ORDEN DE FABRICACIÓN.
//
// Hermano de `operationAttention`, y por la misma razón: devuelve MOTIVOS, no frases. La
// traducción la pone quien pinta, que es quien tiene el `t_`.
//
// ⚠️⚠️ EL CASO QUE NI EL HANDOFF NI YO HABÍAMOS PREVISTO, y que decide la forma de este módulo:
// UNA OPERACIÓN EN CURSO EN LA QUE NADIE QUEDÓ REGISTRADO. Ahí `activeOperationCount > 0` y
// `currentOperationStartedAt` viene AUSENTE **a la vez** — 1 de las 31 en curso de la base de
// referencia. Ninguno de los dos se infiere del otro.
//
// La tentación era pintar igualmente "lleva en curso desde el {fecha}" con la fecha planificada o
// con la de la OF. Sería inventar el día en que arrancó algo que quizá no arrancó ese día, y
// además en ámbar. Aquí el motivo se da CON EL CONTEO Y SIN FECHA: cuántas hay es un dato, desde
// cuándo no se sabe, y callar las dos cosas perdería la primera (RN8).

/**
 * @param {object} header la cabecera de N1
 * @returns {Array<{key: string, days?: number, percent?: number, count?: number, since?: string}>}
 *   en orden de lectura; vacío cuando no hay nada que avisar, que es la respuesta normal.
 */
export const orderAttentionReasons = (header) => {
  const source = header || {}
  const reasons = []

  // 1. El retraso. `lateAgainstTargetDate` es la señal, y los días salen de `deviation`: se exigen
  //    LAS DOS porque un retraso sin magnitud no se puede escribir en esta frase.
  const days = asNumber(source.deviation ? source.deviation.days : null)
  const late = source.lateAgainstTargetDate === true && days !== null && days > 0
  if (late) reasons.push({ key: 'days-late', days })

  // 2. El avance, SOLO si hay retraso y no está terminado. Suelto no dice nada —un 40% a mitad de
  //    plazo es lo normal—; al lado de un retraso explica cuánto queda por recuperar.
  const percent = asNumber(source.progressPercent)
  if (late && percent !== null && percent < 100) reasons.push({ key: 'progress', percent })

  // 3. Las que están en curso. Tres desenlaces, y el tercero es el que no habíamos previsto.
  const count = asNumber(source.activeOperationCount) || 0
  const since = isBlank(source.currentOperationStartedAt) ? '' : source.currentOperationStartedAt
  if (count > 0) {
    // ⚠️ `currentOperation` (el objeto) SOLO viaja cuando hay EXACTAMENTE UNA en curso (S281), así
    // que la fecha NO puede vivir dentro de él: faltaría justo en el caso de varias, que es una de
    // las dos frases. Por eso `currentOperationStartedAt` es hermano de `activeOperationCount`.
    if (since === '') reasons.push({ key: 'active-operations-undated', count })
    else if (count === 1) reasons.push({ key: 'single-active-operation', since })
    else reasons.push({ key: 'active-operations', count, since })
  }

  return reasons
}
